import { Component, OnDestroy, OnInit, AfterViewInit } from '@angular/core';
import * as bootstrap from 'bootstrap';
import { HomeService } from '../services/home.service';
import { Subscription, debounceTime, interval, Subject, forkJoin, of } from 'rxjs';
import { takeUntil, catchError } from 'rxjs/operators';
import { WebSocketService } from '../services/web-socket.service';
import { NgToastService } from 'ng-angular-popup';
import { NgxSpinnerService } from 'ngx-spinner';
import { HttpClient } from '@angular/common/http';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NavigationEnd, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { MatDialog } from '@angular/material/dialog';
import { PopupDialogComponent } from '../popup-dialog/popup-dialog.component';
import { ConfigService } from '../services/config.service';
import { Meta, Title } from '@angular/platform-browser';
import {
  Chart,
  LineElement,
  PointElement,
  LineController,
  CategoryScale,
  LinearScale,
  Filler,
  Tooltip,
  Legend,
  ChartConfiguration,
} from 'chart.js';

// Register only what we need (tree-shakeable)
Chart.register(
  LineElement,
  PointElement,
  LineController,
  CategoryScale,
  LinearScale,
  Filler,
  Tooltip,
  Legend
);



@Component({
  selector: 'app-mobileview',
  templateUrl: './mobileview.component.html',
  styleUrls: ['./mobileview.component.scss'],
})
export class MobileviewComponent implements OnInit, AfterViewInit, OnDestroy {
  // UI State
  showDiv = {
    previous: true,
    current: true,
    next: true,
  };

  // Coins / Bars picker state (Buy Gold / Buy Silver -> "What would you like to buy?")
  selectedOption: 'coins' | 'bars' | null = null;

  // Price Data
  livePrice: any;
  spotGold: any;
  spotSilver: any;
  spotINR: any;
  primium: any = 0;
  spotGoldUpdate: any;
  spotSilverUpdate: any;
  silverPrimium: any = 0;
  buySilverRate: any;
  buyGoldRate: any;

  // Price Locking
  priceLocked: boolean = false;
  lockedGoldPrice: any = null;
  lockedSilverPrice: any = null;
  lockTimer: number = 0;
  lockInterval: any = null;
  stayBuyGoldRate: any;
  stayBuySilverRate: any;

  // Price Colors
  previousSpotGoldUpdate: any = 0;
  previousSpotINRUpdate: any = 0;
  previousSpotSilverUpdate: any = 0;
  spotGoldColor: string = '#e1b737';
  spotSilverColor: string = '#e1b737';
  spotINRColor: string = '#e1b737';

  // Forms
  bookGoldForm: FormGroup;
  bookSilverForm: FormGroup;
  buyGoldForm: FormGroup;
  buySilverForm: FormGroup;

  // Validation Flags
  isTotal: boolean = false;
  isAmountLessThan110: boolean = false;
  isAmountLessThan1000: boolean = false;
  fAmount!: number;

  // User State
  isLogin: boolean = false;
  isNotAllowedTime: boolean = true;
  kyc_status: any;
  profileDetails: any;
  timingsData: any;

  // Trading State
  treding: boolean = false;
  isWeekendDay: boolean = false;
  shouldShowAlert: boolean = false;

  // Limits
  goldMaxLimit: any;
  silverMaxLimit: any;

  // Timer
  timerBuy: number = 30;
  timerSubscriptionBuy: Subscription | null = null;

  // Config Data
  phoneNumbers: string[] = [];
  timings: string = '';
  whatsappNumber: string = '';
  email: string = '';
  address: string = '';
  companyname: any;
  backGroundColor: any;

  // Date
  now: Date = new Date();

  // WebSocket Data
  data: string | undefined;

  // Subscriptions
  private destroy$ = new Subject<void>();
  private timeSubscription: Subscription | undefined;
  public socketSubscription: Subscription | undefined;
  public livePriceSubscription: Subscription | undefined;

  // Token Keys
  private readonly TOKEN_KEYS = [
    'user-access',
    'token',
    'user-token-goldBharatFirst'
  ];

  // ─── CHART & H/L PROPERTIES ───────────────────────────────────────────────
  goldDayHigh: number = 0;
  goldDayLow: number = 999999;
  silverDayHigh: number = 0;
  silverDayLow: number = 999999;
  goldChangePercent: number = 0;
  silverChangePercent: number = 0;
  selectedTimeframe: string = 'today';

  private goldPriceHistory: { time: string; price: number }[] = [];
  private silverPriceHistory: { time: string; price: number }[] = [];
  private trendChart: Chart | null = null;
  private goldOpenPrice: number = 0;
  private silverOpenPrice: number = 0;
  private chartInitialized: boolean = false;
  // ─────────────────────────────────────────────────────────────────────────

  constructor(
    private home: HomeService,
    private webSocketService: WebSocketService,
    private toast: NgToastService,
    private spinner: NgxSpinnerService,
    private http: HttpClient,
    private fb: FormBuilder,
    private router: Router,
    private auth: AuthService,
    public dialog: MatDialog,
    private configService: ConfigService,
    private meta: Meta,
    private titleService: Title
  ) {
    // Initialize Book Gold Form
    this.bookGoldForm = this.fb.group({
      product_name: ['Gold'],
      quantity_purchased: ['', [Validators.required]],
      book_rate: [
        '',
        [
          Validators.required,
          Validators.pattern('^\\d*\\.?\\d*$'),
        ],
      ],
      order_type: ['Gold'],
    });

    // Initialize Book Silver Form
    this.bookSilverForm = this.fb.group({
      product_name: ['Silver'],
      quantity_purchased: ['', [Validators.required]],
      book_rate: [
        '',
        [
          Validators.required,
          Validators.pattern('^\\d*\\.?\\d*$'),
        ],
      ],
      order_type: ['Silver'],
    });

    // Initialize Buy Gold Form
    this.buyGoldForm = this.fb.group({
      product_name: ['Gold'],
      quantity_purchased: ['', [Validators.required]],
      purchased_price: [''],
      order_type: ['Gold'],
    });

    // Initialize Buy Silver Form
    this.buySilverForm = this.fb.group({
      product_name: ['Silver'],
      quantity_purchased: ['', [Validators.required]],
      purchased_price: [''],
      order_type: ['Silver'],
    });
  }

  ngOnInit(): void {
    this.initializeComponent();
  }

  ngAfterViewInit(): void {
    // Clear the bootstrap backdrop whenever any of these modals close
    const modalIds = [
      'buyGoldModalNew',
      'buyGoldModalNewSilver',
      'buyGoldModal',
      'bookGoldModal',
      'buySilverModal',
      'bookSilverModal',
    ];

    modalIds.forEach(id => {
      const modalEl = document.getElementById(id);
      modalEl?.addEventListener('hidden.bs.modal', () => {
        this.clearModalBackdrop();
      });
    });

    // Chart canvas is ready; if we already have data, render immediately
    if (this.goldPriceHistory.length > 0) {
      this.updateTrendChart();
    }
  }

  private initializeComponent(): void {
    this.cleanupLocalStorage();

    forkJoin({
      config: this.loadConfigSafe(),
      initialRates: this.home.getInitialRates().pipe(catchError(() => of(null)))
    }).subscribe({
      next: (results) => {
        if (results.config) {
          this.applyConfig(results.config);
        }
        if (results.initialRates) {
          this.handleInitialRates(results.initialRates);
        }
      },
      complete: () => {
        this.checkLoginAndTime();
        this.checkTime();
        this.setMetaTags();
        this.setupRouterEvents();
        this.setupWebSocket();
        this.startTimeUpdates();
        this.isWeekend();
      }
    });
  }

  private cleanupLocalStorage(): void {
    const keysToCheck = ['userData', 'user-details-goldBharat', 'user-token-goldBharatFirst'];
    keysToCheck.forEach(key => {
      const value = localStorage.getItem(key);
      if (value === 'undefined' || value === 'null') {
        localStorage.removeItem(key);
      }
    });

    const userDataString = localStorage.getItem('userData');
    if (userDataString) {
      try {
        JSON.parse(userDataString);
      } catch {
        localStorage.removeItem('userData');
      }
    }
  }

  private loadConfigSafe() {
    return this.configService.loadConfig().pipe(
      catchError(error => {
        console.error('Error loading config:', error);
        return of(null);
      })
    );
  }

  private applyConfig(config: any): void {
    if (config?.contact) {
      this.phoneNumbers = config.contact.phoneNumbers || [];
      this.timings = config.contact.timings || '';
      this.whatsappNumber = config.contact.whatsappNumber || '';
      this.email = config.contact.email || '';
      this.address = config.contact.address || '';
      this.companyname = config.company?.companyname || '';
      this.backGroundColor = config.company;
    }
  }

  private handleInitialRates(data: any): void {
    if (data) {
      this.spotGoldUpdate = data.carat24?.sell_price_per_gram;
      this.spotSilverUpdate = data.silverPrice?.sell_price_per_gram;
      this.spotGold = data.carat24?.spot_gold;
      this.spotSilver = data.silverPrice?.spot_silver;
      this.spotINR = data.carat24?.spot_inr;

      this.stayBuyGoldRate = this.spotGoldUpdate;
      this.stayBuySilverRate = this.spotSilverUpdate;

      // Seed H/L and history with initial rates
      this.recordPriceHistory();
    }
  }

  private setMetaTags(): void {
    this.titleService.setTitle('Buy Gold & Silver In Bulk At Best Price | Goldbharat');

    this.meta.updateTag({
      name: 'description',
      content: 'Buy bulk gold and silver at unbeatable prices. Secure your wealth with high-quality precious metals, ideal for investors seeking long-term reliability and value protection.',
    });

    this.meta.updateTag({
      name: 'keywords',
      content: 'buy gold wholesale, buy gold in bulk, buy gold wholesale direct, gold price today',
    });
  }

  private setupRouterEvents(): void {
    this.router.events
      .pipe(takeUntil(this.destroy$))
      .subscribe((event: any) => {
        if (event instanceof NavigationEnd) {
          window.scrollTo(0, 0);
        }
      });
  }

  private setupWebSocket(): void {
    this.spotGoldUpdate = 0;
    this.spotSilverUpdate = 0;
    this.previousSpotGoldUpdate = 0;
    this.previousSpotINRUpdate = 0;
    this.previousSpotSilverUpdate = 0;

    this.spotGoldColor = '#e1b737';
    this.spotSilverColor = '#e1b737';
    this.spotINRColor = '#e1b737';

    this.socketSubscription = this.webSocketService
      .startFetching()
      .pipe(
        debounceTime(500),
        takeUntil(this.destroy$)
      )
      .subscribe({
        next: (message: string) => {
          this.handleWebSocketMessage(message);
        },
        error: (error: any) => {
          console.error('WebSocket error:', error);
        }
      });
  }

  private startTimeUpdates(): void {
    this.timeSubscription = interval(1000)
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.updateTime();
      });
  }

  updateTime(): void {
    this.now = new Date();
  }

  isWeekend(): void {
    this.now = new Date();
    const day = this.now.toLocaleString('en-us', { weekday: 'short' });
    const isWeekend = day === 'Sat' || day === 'Sun';

    if (this.kyc_status !== 2) {
      this.treding = !isWeekend;
      this.isWeekendDay = isWeekend;
    } else {
      this.treding = true;
      this.isWeekendDay = false;
    }
  }

  checkTime(): void {
    const now = new Date();
    const currentHour = now.getHours();
    const currentMinute = now.getMinutes();
    const currentDay = now.getDay();

    const isBefore930AM =
      currentHour < 9 || (currentHour === 9 && currentMinute < 30);
    const isAfter1130PM =
      currentHour > 23 || (currentHour === 23 && currentMinute >= 30);
    const isWeekday = currentDay >= 1 && currentDay <= 5;

    this.shouldShowAlert = (isBefore930AM || isAfter1130PM) && isWeekday;
  }

  private getToken(): string | null {
    for (const key of this.TOKEN_KEYS) {
      const token = localStorage.getItem(key);
      if (token && token !== 'undefined' && token !== 'null') {
        return token;
      }
    }
    return null;
  }

  private getUserData(): any {
    const userDataString = localStorage.getItem('userData');
    if (!userDataString || userDataString === 'undefined' || userDataString === 'null') {
      return null;
    }
    try {
      return JSON.parse(userDataString);
    } catch {
      return null;
    }
  }

  checkLoginAndTime(): void {
    const token = this.getToken();
    this.isLogin = !!token;

    const now = new Date();
    const currentHour = now.getHours();
    const currentMinute = now.getMinutes();

    const isRestrictedTime = (currentHour === 23 && currentMinute >= 30) ||
      (currentHour >= 0 && currentHour < 9) ||
      (currentHour === 9 && currentMinute < 30);

    this.isNotAllowedTime = !isRestrictedTime;

    if (this.isLogin && this.isNotAllowedTime) {
      this.userProfile();
    }
  }

  userAmount(userInput: any): void {
    if (userInput) {
      const livePrice = parseFloat(this.priceLocked && this.lockedGoldPrice ? this.lockedGoldPrice : this.spotGoldUpdate);
      const enteredAmount = parseFloat(userInput);

      if (isNaN(enteredAmount)) {
        this.isAmountLessThan110 = false;
        return;
      }

      const difference = livePrice - enteredAmount;

      if (difference >= 0 && difference <= 110) {
        this.isAmountLessThan110 = true;
      } else {
        this.isAmountLessThan110 = false;

        if (enteredAmount > livePrice) {
          this.toast.warning({
            detail: 'Invalid Amount',
            summary: `Booking amount cannot be higher than locked price (₹${livePrice.toFixed(2)})`,
            position: 'topCenter',
          });
        } else if (difference > 110) {
          this.toast.warning({
            detail: 'Invalid Amount',
            summary: `Amount too low. Must be within ₹110 of locked price. Minimum allowed: ₹${(livePrice - 110).toFixed(2)}`,
            position: 'topCenter',
          });
        }
      }
    }
  }

  userAmountSilver(userInput: any): void {
    if (userInput) {
      const livePrice = parseFloat(this.priceLocked && this.lockedSilverPrice ? this.lockedSilverPrice : this.spotSilverUpdate);
      const enteredAmount = parseFloat(userInput);

      if (isNaN(enteredAmount)) {
        this.isAmountLessThan1000 = false;
        return;
      }

      const difference = livePrice - enteredAmount;

      if (difference >= 0 && difference <= 1000) {
        this.isAmountLessThan1000 = true;
      } else {
        this.isAmountLessThan1000 = false;

        if (enteredAmount > livePrice) {
          this.toast.warning({
            detail: 'Invalid Amount',
            summary: `Booking amount cannot be higher than locked price (₹${livePrice.toFixed(2)})`,
            position: 'topCenter',
          });
        } else if (difference > 1000) {
          this.toast.warning({
            detail: 'Invalid Amount',
            summary: `Amount too low. Must be within ₹1000 of locked price. Minimum allowed: ₹${(livePrice - 1000).toFixed(2)}`,
            position: 'topCenter',
          });
        }
      }
    }
  }

  checkLogIn(): void {
    this.toast.warning({
      detail: 'Login Required!',
      summary: 'Please login for book gold',
      position: 'topCenter',
    });
  }

  // ─── UPDATED: now also writes lockedPriceData to localStorage,
  //     matching the homepage component so gold-coins page picks it up ────
  lockPrice(type: string): void {
    if (this.lockInterval) {
      clearInterval(this.lockInterval);
    }

    if (type === 'Gold') {
      this.lockedGoldPrice = this.stayBuyGoldRate;
    } else {
      this.lockedSilverPrice = this.stayBuySilverRate;
    }

    this.priceLocked = true;
    this.lockTimer = 30;

    this.lockInterval = setInterval(() => {
      this.lockTimer--;
      if (this.lockTimer <= 0) {
        this.unlockPrice();
      }
    }, 1000);

    console.log(`Price locked for ${type} at ${type === 'Gold' ? this.lockedGoldPrice : this.lockedSilverPrice} for 30 seconds`);

    const lockData = {
      type: type,
      lockedPrice: type === 'Gold' ? this.lockedGoldPrice : this.lockedSilverPrice,
      timer: this.lockTimer,
      lockedAt: new Date().toISOString()
    };

    localStorage.setItem('lockedPriceData', JSON.stringify(lockData));

    console.log(lockData.lockedPrice, 'mobileview newwwwwwwLocked');
  }

  // ─── UPDATED: also clears lockedPriceData from localStorage on unlock ───
  unlockPrice(): void {
    this.priceLocked = false;
    this.lockedGoldPrice = null;
    this.lockedSilverPrice = null;
    this.lockTimer = 0;

    if (this.lockInterval) {
      clearInterval(this.lockInterval);
      this.lockInterval = null;
    }

    localStorage.removeItem('lockedPriceData');

    console.log('Price unlocked (mobileview)');
  }

  // onBuySubmit(value: string): void {
  //   const token = this.getToken();
  //   if (!token) {
  //     this.toast.warning({
  //       detail: 'Login Required',
  //       summary: 'Please login to make a purchase',
  //       position: 'topCenter',
  //     });
  //     this.router.navigate(['/login']);
  //     return;
  //   }

  //   if (value === 'Gold' && !this.lockedGoldPrice) {
  //     this.toast.warning({
  //       detail: 'Price Expired',
  //       summary: 'Please click on Buy button again to refresh the price',
  //       position: 'topCenter',
  //     });
  //     return;
  //   }

  //   if (value === 'Silver' && !this.lockedSilverPrice) {
  //     this.toast.warning({
  //       detail: 'Price Expired',
  //       summary: 'Please click on Buy button again to refresh the price',
  //       position: 'topCenter',
  //     });
  //     return;
  //   }

  //   const form = value === 'Gold' ? this.buyGoldForm : this.buySilverForm;

  //   if (!form.valid) {
  //     this.toast.warning({
  //       detail: 'Invalid Form',
  //       summary: 'Please fill all required fields',
  //       position: 'topCenter',
  //     });
  //     return;
  //   }

  //   const quantity = form.get('quantity_purchased')?.value;
  //   if (!quantity) {
  //     this.toast.warning({
  //       detail: 'Quantity Required',
  //       summary: 'Please select a quantity',
  //       position: 'topCenter',
  //     });
  //     return;
  //   }

  //   const price = value === 'Gold' ? this.lockedGoldPrice : this.lockedSilverPrice;
  //   const formattedPrice = value === 'Gold'
  //     ? Math.floor(parseFloat(price)).toString()
  //     : parseFloat(price).toFixed(2);

  //   const orderData = {
  //     product_name: value,
  //     quantity_purchased: quantity.toString(),
  //     purchased_price: formattedPrice,
  //     order_type: value
  //   };

  //   this.spinner.show();

  //   this.home.buyGoldAnsSilver(orderData)
  //     .pipe(takeUntil(this.destroy$))
  //     .subscribe({
  //       next: (res: any) => {
  //         this.spinner.hide();
  //         this.toast.success({
  //           detail: 'Success!',
  //           summary: res.msg || 'Order placed successfully',
  //           position: 'topCenter',
  //         });
  //         form.reset();
  //         this.resetFormDefaults(value, 'buy');
  //         this.unlockPrice();
  //         this.goldLimit();
  //         this.silverLimit();
  //       },
  //       error: (err: any) => {
  //         this.spinner.hide();
  //         if (err.status === 401) {
  //           this.handleSessionExpired();
  //         } else {
  //           this.toast.error({
  //             detail: 'Oops!',
  //             summary: err.error?.msg || 'Something went wrong',
  //             position: 'topCenter',
  //           });
  //         }
  //       }
  //     });
  // }

  onBuySubmit(value: string): void {
    debugger;
    const token = this.getToken();
    if (!token) {
      this.toast.warning({
        detail: 'Login Required',
        summary: 'Please login to make a purchase',
        position: 'topCenter',
      });
      this.router.navigate(['/login']);
      return;
    }

    // Check if price is locked for this type
    if (value === 'Gold' && !this.lockedGoldPrice) {
      this.toast.warning({
        detail: 'Price Expired',
        summary: 'Please click on Buy button again to refresh the price',
        position: 'topCenter',
      });
      return;
    }

    if (value === 'Silver' && !this.lockedSilverPrice) {
      this.toast.warning({
        detail: 'Price Expired',
        summary: 'Please click on Buy button again to refresh the price',
        position: 'topCenter',
      });
      return;
    }

    if (!this.buyGoldForm.valid) {
      this.toast.warning({
        detail: 'Invalid Form',
        summary: 'Please fill all required fields',
        position: 'topCenter',
      });
      return;
    }

    const quantity = this.buyGoldForm.get('quantity_purchased')?.value;
    if (!quantity) {
      this.toast.warning({
        detail: 'Quantity Required',
        summary: 'Please select a quantity',
        position: 'topCenter',
      });
      return;
    }

    // Use locked price instead of live price
    const price = value === 'Gold' ? this.lockedGoldPrice : this.lockedSilverPrice;

    // Format price for backend
    const formattedPrice = value === 'Gold'
      ? Math.floor(parseFloat(price)).toString()
      : parseFloat(price).toFixed(2);

    const orderData = {
      product_name: value,
      quantity_purchased: quantity.toString(),
      purchased_price: formattedPrice,
      order_type: value
    };

    console.log('Sending order data with locked price:', orderData);

    this.spinner.show();

    this.home.buyGoldAnsSilver(orderData)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          this.spinner.hide();
          this.toast.success({
            detail: 'Success!',
            summary: res.msg || 'Order placed successfully',
            position: 'topCenter',
          });
          this.buyGoldForm.reset();
          this.unlockPrice(); // Unlock price after successful purchase
          this.goldLimit();
          this.silverLimit();

          setTimeout(() => {
            this.router.navigate(['/orders']);
          }, 1000);
        },
        error: (err: any) => {
          this.spinner.hide();
          console.error('Order error:', err);
          if (err.status === 401) {
            this.handleSessionExpired();
          } else {
            this.toast.error({
              detail: 'Oops!',
              summary: err.error?.msg || 'Something went wrong',
              position: 'topCenter',
            });
          }
        }
      });
  }

  onGoldSubmit(value: string): void {
    const token = this.getToken();
    if (!token) {
      this.toast.warning({
        detail: 'Login Required',
        summary: 'Please login to book gold/silver',
        position: 'topCenter',
      });
      this.router.navigate(['/login']);
      return;
    }

    if (value === 'gold' && !this.lockedGoldPrice) {
      this.toast.warning({
        detail: 'Price Expired',
        summary: 'Please click on Book button again to refresh the price',
        position: 'topCenter',
      });
      return;
    }

    if (value === 'silver' && !this.lockedSilverPrice) {
      this.toast.warning({
        detail: 'Price Expired',
        summary: 'Please click on Book button again to refresh the price',
        position: 'topCenter',
      });
      return;
    }

    const form = value === 'gold' ? this.bookGoldForm : this.bookSilverForm;

    if (!form.valid) {
      this.toast.warning({
        detail: 'Invalid Form',
        summary: 'Please fill all required fields',
        position: 'topCenter',
      });
      return;
    }

    const quantity = form.get('quantity_purchased')?.value;
    const bookRate = form.get('book_rate')?.value;

    if (!quantity || !bookRate) {
      this.toast.warning({
        detail: 'Missing Information',
        summary: 'Please select quantity and enter amount',
        position: 'topCenter',
      });
      return;
    }

    const livePrice = value === 'gold'
      ? parseFloat(this.lockedGoldPrice)
      : parseFloat(this.lockedSilverPrice);

    const enteredAmount = parseFloat(bookRate);
    const difference = livePrice - enteredAmount;

    if (value === 'gold' && (difference < 0 || difference > 110)) {
      this.toast.warning({
        detail: 'Invalid Amount',
        summary: `Amount must be between ₹${(livePrice - 110).toFixed(2)} and ₹${livePrice.toFixed(2)}`,
        position: 'topCenter',
      });
      return;
    }

    if (value === 'silver' && (difference < 0 || difference > 1000)) {
      this.toast.warning({
        detail: 'Invalid Amount',
        summary: `Amount must be between ₹${(livePrice - 1000).toFixed(2)} and ₹${livePrice.toFixed(2)}`,
        position: 'topCenter',
      });
      return;
    }

    const bookingData = {
      product_name: value === 'gold' ? 'Gold' : 'Silver',
      quantity_purchased: quantity.toString(),
      book_rate: bookRate.toString(),
      order_type: value === 'gold' ? 'Gold' : 'Silver'
    };

    this.spinner.show();

    this.home.bookGoldAndSilver(bookingData)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          this.spinner.hide();
          this.toast.success({
            detail: 'Success!',
            summary: res.msg || 'Booking successful',
            position: 'topCenter',
          });
          form.reset();
          this.resetFormDefaults(value, 'book');
          this.unlockPrice();
          this.goldLimit();
          this.silverLimit();
        },
        error: (err: any) => {
          this.spinner.hide();
          if (err.status === 401) {
            this.handleSessionExpired();
          } else {
            this.toast.error({
              detail: 'Error!',
              summary: err.error?.msg || 'Something went wrong',
              position: 'topCenter',
            });
          }
        }
      });
  }

  private resetFormDefaults(value: string, type: 'buy' | 'book'): void {
    if (type === 'book') {
      if (value === 'gold') {
        this.bookGoldForm.patchValue({ product_name: 'Gold', order_type: 'Gold' });
      } else {
        this.bookSilverForm.patchValue({ product_name: 'Silver', order_type: 'Silver' });
      }
    } else {
      if (value === 'Gold') {
        this.buyGoldForm.patchValue({ product_name: 'Gold', order_type: 'Gold' });
      } else {
        this.buySilverForm.patchValue({ product_name: 'Silver', order_type: 'Silver' });
      }
    }
  }

  private handleSessionExpired(): void {
    this.TOKEN_KEYS.forEach(key => localStorage.removeItem(key));
    localStorage.removeItem('userData');
    localStorage.removeItem('user-details-goldBharat');

    this.isLogin = false;
    this.kyc_status = null;
    this.profileDetails = null;

    this.toast.warning({
      detail: 'Session Expired',
      summary: 'Please login again to continue',
      duration: 3000,
      position: 'topCenter'
    });

    this.router.navigate(['/login']);
  }

  openDialog(): void {
    this.dialog.open(PopupDialogComponent, {
      width: '500px',
      panelClass: 'custom-dialog-container',
    });
  }

  private handleWebSocketMessage(message: string): void {
    this.data = message;

    if (!message || message === 'undefined' || message === 'null' || message.trim() === '' || message.length < 2) {
      return;
    }

    try {
      if (message.startsWith('42')) {
        const jsonStr = message.substring(2);
        if (!jsonStr || jsonStr.trim() === '' || jsonStr === 'undefined') return;

        const jsonMessage = JSON.parse(jsonStr);
        if (!Array.isArray(jsonMessage) || jsonMessage.length < 2) return;

        const priceData = jsonMessage[1];
        if (!priceData || !priceData.updatedata) return;

        const eventData = priceData.updatedata;
        if (eventData === 'undefined' || !eventData) return;

        const jsonData = JSON.parse(eventData);
        const dataArray = Array.isArray(jsonData) ? jsonData : [jsonData];

        const filteredData = dataArray.filter(
          (item: any) => item?.gold1_symbol &&
            ['SPOT-INR', 'SPOT-SILVER', 'SPOT-GOLD'].includes(item.gold1_symbol)
        );

        if (filteredData.length >= 3) {
          filteredData.forEach((item: any) => {
            switch (item.gold1_symbol) {
              case 'SPOT-GOLD':
                this.spotGold = item.gold1_ask;
                break;
              case 'SPOT-SILVER':
                this.spotSilver = item.gold1_ask;
                break;
              case 'SPOT-INR':
                this.spotINR = item.gold1_ask;
                break;
            }
          });

          if (!this.priceLocked) {
            this.fetchPremiums();
          }
        }
      }
    } catch (error) {
      // Silent fail
    }
  }

  private fetchPremiums(): void {
    this.http.get('https://liverates-api.goldcentral.in/api/getpremium')
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          if (res?.premium !== undefined) {
            this.primium = res.premium;
            this.fetchSilverPremium();
          }
        },
        error: (error: any) => {
          console.error('Error fetching premium:', error);
        }
      });
  }

  private fetchSilverPremium(): void {
    this.http.get('https://liverates-api.goldcentral.in/api/getSilverPremium')
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          if (res?.premium !== undefined) {
            this.silverPrimium = res.premium;
            this.calculateUpdatedPrices();
          }
        },
        error: (error: any) => {
          console.error('Error fetching silver premium:', error);
        }
      });
  }

  private calculateUpdatedPrices(): void {
    const ozToGrams = 31.102;
    const GOV_GOLD_TAX = 6.25;
    const GOV_SILVER_TAX = 6.75;
    const GST_TAX_PERCENTAGE = 0;

    const totalChargesPercentage = GOV_GOLD_TAX + GST_TAX_PERCENTAGE;

    // Gold price calculation
    const checkGold1 = this.spotGold / ozToGrams;
    const INRrupeeGold = checkGold1 * this.spotINR;
    let convGold: number = (INRrupeeGold / 100) * totalChargesPercentage + INRrupeeGold;
    convGold += (convGold * this.primium) / 100;
    this.spotGoldUpdate = convGold.toFixed(2);

    if (!this.priceLocked || !this.lockedGoldPrice) {
      this.stayBuyGoldRate = this.spotGoldUpdate;
    }

    // Silver price calculation
    const checkSilver = (this.spotSilver / 31.1) * this.spotINR * 1000;
    const inrSilver = checkSilver + (checkSilver / 100) * GOV_SILVER_TAX;
    const finalSilver = inrSilver + (inrSilver * this.silverPrimium) / 1000;
    this.spotSilverUpdate = (finalSilver + 100).toFixed(2);

    if (!this.priceLocked || !this.lockedSilverPrice) {
      this.stayBuySilverRate = this.spotSilverUpdate;
    }

    this.updatePriceColors();
    this.recordPriceHistory();  // ← update chart & H/L on every price tick
  }

  private updatePriceColors(): void {
    this.spotGoldColor = this.getColor(this.spotGoldUpdate, this.previousSpotGoldUpdate);
    this.spotINRColor = this.getColor(this.spotINR, this.previousSpotINRUpdate);
    this.spotSilverColor = this.getColor(this.spotSilverUpdate, this.previousSpotSilverUpdate);

    setTimeout(() => {
      this.previousSpotGoldUpdate = this.spotGoldUpdate;
      this.previousSpotSilverUpdate = this.spotSilverUpdate;
      this.previousSpotINRUpdate = this.spotINR;
    }, 100);
  }

  private getColor(current: number | string, previous: number | string): string {
    const currentNum = typeof current === 'string' ? parseFloat(current) : current;
    const previousNum = typeof previous === 'string' ? parseFloat(previous) : previous;

    if (currentNum > previousNum) return '#FE4A54';
    if (currentNum < previousNum) return '#76f590';
    return '#e1b737';
  }

  public isWeekendCheck(): boolean {
    const currentDay = new Date().getDay();
    return currentDay === 0 || currentDay === 6;
  }

  callLimit(value: string): void {
    const token = this.getToken();
    if (!token) {
      this.toast.warning({
        detail: 'Login Required',
        summary: 'Please login to view limits',
        position: 'topCenter',
      });
      this.router.navigate(['/login']);
      return;
    }

    this.lockPrice(value);

    if (value === 'Gold') {
      this.goldLimit();
      this.timerBuy = 30;
      this.startTimer();
    } else {
      this.silverLimit();
      this.timerBuy = 30;
      this.startTimer();
    }
  }

  goldLimit(): void {
    this.home.getGoldLimit()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          this.goldMaxLimit = res.maxLimitValues;
        },
        error: (err: any) => {
          if (err.status === 401) {
            this.handleSessionExpired();
          } else {
            console.error('Error fetching gold limit:', err);
          }
        }
      });
  }

  silverLimit(): void {
    this.home.getSilverLimit()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          this.silverMaxLimit = res.silverMaxLimitValues;
        },
        error: (err: any) => {
          if (err.status === 401) {
            this.handleSessionExpired();
          } else {
            console.error('Error fetching silver limit:', err);
          }
        }
      });
  }

  userProfile(): void {
    const token = this.getToken();
    if (!token) {
      this.isLogin = false;
      return;
    }

    this.auth.userDetailGet()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          if (res.success) {
            const data = res.data;
            this.profileDetails = data.userData;
            this.kyc_status = data.kyc_status;

            if (data.userData) {
              const userDataToStore = {
                id: data.userData?.id,
                kyc_status: data.kyc_status,
                ...data.userData
              };
              localStorage.setItem('userData', JSON.stringify(userDataToStore));
            }

            if (data.token) {
              const newToken = data.token.startsWith('Bearer ') ? data.token : `Bearer ${data.token}`;
              localStorage.setItem('user-access', newToken);
            }

            this.getTimingsbyId();
          }
        },
        error: (err: any) => {
          if (err.status === 401) {
            this.handleSessionExpired();
          } else {
            console.error('Error fetching user profile:', err);
          }
        }
      });
  }

  getWhatsAppLink(number: string): string {
    const formattedNumber = number.replace(/\D/g, '');
    return `https://wa.me/${formattedNumber}`;
  }

  getTimingsbyId(): void {
    const userData = this.getUserData();
    if (!userData || !userData?.id) return;

    const token = this.getToken();
    if (!token) return;

    if (userData.kyc_status !== 0 && userData.kyc_status !== undefined) {
      this.home.getTimings(userData.id)
        .pipe(
          takeUntil(this.destroy$),
          catchError(err => {
            if (err.status === 401) this.handleSessionExpired();
            return of(null);
          })
        )
        .subscribe({
          next: (response: any) => {
            if (response) {
              this.timingsData = response;
            }
          }
        });
    }
  }

  goldSilverRateStay(): void {
    this.home.getInitialRates()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data: any) => {
          if (data) {
            if (!this.priceLocked || !this.lockedGoldPrice) {
              this.stayBuyGoldRate = data.carat24?.sell_price_per_gram;
            }
            if (!this.priceLocked || !this.lockedSilverPrice) {
              this.stayBuySilverRate = data.silverPrice?.sell_price_per_gram;
            }
          }
        },
        error: (err: any) => {
          console.error('Error fetching rates:', err);
        }
      });
  }

  startTimer(): void {
    this.stopTimer();

    this.timerSubscriptionBuy = interval(1000)
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.timerBuy--;
        if (this.timerBuy <= 0) {
          this.timerBuy = 30;
          if (!this.priceLocked) {
            this.goldSilverRateStay();
          }
        }
      });
  }

  stopTimer(): void {
    if (this.timerSubscriptionBuy) {
      this.timerSubscriptionBuy.unsubscribe();
      this.timerSubscriptionBuy = null;
    }
  }

  // Updated closeModal to unlock price + reset picker state + clear backdrop
  closeModal(): void {
    this.stopTimer();
    this.unlockPrice();
    this.selectedOption = null;

    const openModalEl = document.querySelector('.modal.show') as HTMLElement | null;

    if (openModalEl) {
      const modalInstance = bootstrap.Modal.getOrCreateInstance(openModalEl);

      openModalEl.addEventListener('hidden.bs.modal', () => {
        this.forceClearAllBackdrops();
      }, { once: true });

      modalInstance.hide();

      setTimeout(() => {
        this.forceClearAllBackdrops();
      }, 400);

    } else {
      this.forceClearAllBackdrops();
    }
  }

  forceClearAllBackdrops(): void {
    document.querySelectorAll('.modal-backdrop').forEach((el: any) => {
      el.remove();
    });

    document.querySelectorAll('.modal').forEach((modal: any) => {
      modal.classList.remove('show');
      modal.setAttribute('aria-hidden', 'true');
      modal.style.display = 'none';
    });

    document.body.classList.remove('modal-open');
    document.body.style.removeProperty('overflow');
    document.body.style.removeProperty('padding-right');
  }

  // Gold picker ("What would you like to buy?") -> Bars option -> opens direct Buy Gold modal
  switchToBuyGoldModal(): void {
    const currentModalEl = document.getElementById('buyGoldModalNew');
    const currentModal = bootstrap.Modal.getInstance(currentModalEl!);

    currentModalEl?.addEventListener('hidden.bs.modal', () => {
      this.clearModalBackdrop();
      const nextModalEl = document.getElementById('buyGoldModal');
      const nextModal = new bootstrap.Modal(nextModalEl!);
      nextModal.show();
    }, { once: true });

    currentModal?.hide();
    this.selectedOption = 'bars';
  }

  // Silver picker ("What would you like to buy?") -> Bars option -> opens direct Buy Silver modal
  switchToBuyGoldModalsilver(): void {
    const currentModalEl = document.getElementById('buyGoldModalNewSilver');
    const currentModal = bootstrap.Modal.getOrCreateInstance(currentModalEl!);

    currentModalEl?.addEventListener('hidden.bs.modal', () => {
      this.forceClearAllBackdrops();
      const nextModalEl = document.getElementById('buySilverModal');
      const nextModal = bootstrap.Modal.getOrCreateInstance(nextModalEl!);
      nextModal.show();
    }, { once: true });

    currentModal.hide();
    this.selectedOption = 'bars';
  }

  private clearModalBackdrop(): void {
    const openModals = document.querySelectorAll('.modal.show');
    const backdrops = document.querySelectorAll('.modal-backdrop');

    if (openModals.length === 0 && backdrops.length > 0) {
      document.body.classList.remove('modal-open');
      document.body.style.removeProperty('overflow');
      document.body.style.removeProperty('padding-right');
      backdrops.forEach(el => el.remove());
    }
  }

  // Gold/Silver picker -> Coins option -> navigates to the gold-coins builder page
  selectOption(
    option: 'coins' | 'bars',
    metalType: 'Gold' | 'Silver'
  ): void {

    this.selectedOption = option;

    const modalId =
      metalType === 'Gold'
        ? 'buyGoldModalNew'
        : 'buyGoldModalNewSilver';

    const modalEl = document.getElementById(modalId);

    const modalInstance = bootstrap.Modal.getInstance(modalEl!);

    modalEl?.addEventListener(
      'hidden.bs.modal',
      () => {
        this.forceClearAllBackdrops();
        this.router.navigate(['/gold-coins'], {
          queryParams: {
            metalType: metalType,
            from: 'mobileview'
          }
        });
      },
      { once: true }
    );

    modalInstance?.hide();
  }

  // ─── CHART & H/L METHODS ──────────────────────────────────────────────────

  /**
   * Called after every price calculation tick.
   * Records a new data point and updates H/L, % change, and the chart.
   */
  private recordPriceHistory(): void {
    const goldPrice = parseFloat(this.spotGoldUpdate);
    const silverPrice = parseFloat(this.spotSilverUpdate);

    if (!goldPrice || !silverPrice || isNaN(goldPrice) || isNaN(silverPrice)) return;

    // Set open price (first seen price of the session)
    if (this.goldOpenPrice === 0) this.goldOpenPrice = goldPrice;
    if (this.silverOpenPrice === 0) this.silverOpenPrice = silverPrice;

    // Update Day High / Low
    if (goldPrice > this.goldDayHigh) this.goldDayHigh = goldPrice;
    if (goldPrice < this.goldDayLow)  this.goldDayLow  = goldPrice;
    if (silverPrice > this.silverDayHigh) this.silverDayHigh = silverPrice;
    if (silverPrice < this.silverDayLow)  this.silverDayLow  = silverPrice;

    // Change % vs session open
    this.goldChangePercent   = ((goldPrice   - this.goldOpenPrice)   / this.goldOpenPrice)   * 100;
    this.silverChangePercent = ((silverPrice - this.silverOpenPrice) / this.silverOpenPrice) * 100;

    // Time label
    const now = new Date();
    const timeLabel = now.toLocaleTimeString('en-IN', {
      hour:   '2-digit',
      minute: '2-digit',
    });

    // Append & cap at 60 points (≈ 1 point every WebSocket tick, ~30 min of data)
    this.goldPriceHistory.push({ time: timeLabel, price: goldPrice });
    this.silverPriceHistory.push({ time: timeLabel, price: silverPrice });

    if (this.goldPriceHistory.length   > 60) this.goldPriceHistory.shift();
    if (this.silverPriceHistory.length > 60) this.silverPriceHistory.shift();

    this.updateTrendChart();
  }

  /**
   * Creates or updates the Chart.js line chart.
   */
  private updateTrendChart(): void {
    const canvas = document.getElementById('trendChart') as HTMLCanvasElement | null;
    if (!canvas) return;

    const labels     = this.goldPriceHistory.map(p => p.time);
    const goldData   = this.goldPriceHistory.map(p => p.price);
    const silverData = this.silverPriceHistory.map(p => p.price);

    // If the chart already exists, just push new data without re-creating it
    if (this.trendChart) {
      this.trendChart.data.labels                    = labels;
      this.trendChart.data.datasets[0].data          = goldData;
      this.trendChart.data.datasets[1].data          = silverData;
      this.trendChart.update('none');   // 'none' skips animation for performance
      return;
    }

    // First-time creation
    const config: ChartConfiguration<'line'> = {
      type: 'line',
      data: {
        labels,
        datasets: [
          {
            label: 'Gold (₹/g)',
            data: goldData,
            borderColor: '#e1b737',
            backgroundColor: 'rgba(225,183,55,0.12)',
            borderWidth: 2,
            pointRadius: 0,
            pointHoverRadius: 4,
            fill: true,
            tension: 0.4,
            yAxisID: 'yGold',
          },
          {
            label: 'Silver (₹/kg)',
            data: silverData,
            borderColor: '#a8aab1',
            backgroundColor: 'rgba(168,170,177,0.06)',
            borderWidth: 2,
            pointRadius: 0,
            pointHoverRadius: 4,
            fill: false,
            tension: 0.4,
            yAxisID: 'ySilver',
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        animation: { duration: 0 },
        interaction: { mode: 'index', intersect: false },
        plugins: {
          legend: { display: false },
          tooltip: {
            backgroundColor: '#030F55',
            titleColor: '#a0a8c8',
            bodyColor: '#ffffff',
            borderColor: '#464E8A',
            borderWidth: 1,
            padding: 10,
            callbacks: {
              label: (ctx) => {
                const val = ctx.parsed.y;
                return ctx.datasetIndex === 0
                  ? ` Gold: ₹${(val ?? 0).toFixed(2)}/g`
                  : ` Silver: ₹${(val ?? 0).toFixed(2)}/kg`;
              },
            },
          },
        },
        scales: {
          x: {
            ticks: {
              color: '#a0a8c8',
              maxTicksLimit: 6,
              font: { size: 10 },
            },
            grid: { color: 'rgba(255,255,255,0.05)' },
          },
          yGold: {
            position: 'left',
            ticks: { color: '#e1b737', font: { size: 10 } },
            grid: { color: 'rgba(255,255,255,0.05)' },
          },
          ySilver: {
            position: 'right',
            ticks: { color: '#a8aab1', font: { size: 10 } },
            grid: { drawOnChartArea: false },
          },
        },
      },
    };

    this.trendChart = new Chart(canvas, config);
    this.chartInitialized = true;
  }

  /**
   * Called when the timeframe dropdown changes.
   * Resets history and destroys the current chart so it rebuilds fresh.
   */
  onTimeframeChange(): void {
    this.goldPriceHistory   = [];
    this.silverPriceHistory = [];
    this.goldOpenPrice      = 0;
    this.silverOpenPrice    = 0;
    this.goldDayHigh        = 0;
    this.goldDayLow         = 999999;
    this.silverDayHigh      = 0;
    this.silverDayLow       = 999999;
    this.goldChangePercent  = 0;
    this.silverChangePercent = 0;

    if (this.trendChart) {
      this.trendChart.destroy();
      this.trendChart = null;
    }
  }

  // ─────────────────────────────────────────────────────────────────────────

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();

    this.stopTimer();

    // Clear lock interval
    if (this.lockInterval) {
      clearInterval(this.lockInterval);
    }

    if (this.timeSubscription) {
      this.timeSubscription.unsubscribe();
    }

    if (this.socketSubscription) {
      this.socketSubscription.unsubscribe();
    }

    // Destroy chart to prevent memory leak
    if (this.trendChart) {
      this.trendChart.destroy();
      this.trendChart = null;
    }
  }
}